export default {"src":"/_next/static/media/passport.ada70f78.svg","height":69,"width":59,"blurWidth":0,"blurHeight":0};